import { apiMillennium } from '../../api'

const AwaitHandling = async () => {
	const res = await apiMillennium.get('/ag-faturamento')
	return res
}

export default AwaitHandling